import React, { memo } from 'react';

import { Content, Section, Table, Title } from '@src/components/ui/Table';
import { useDictionariesFieldsMap } from '@src/reducers/dictionaries';
import { useCard } from '@src/reducers/product';
import { considerationTimeText, obtainingMethodText, registrationWayText } from '@src/utils/texts';

interface IProps {
  className?: string;
}

function renderTableRow(text?: [string, string]) {
  if (!text) {
    return null;
  }

  const [name, value] = text;

  return (
    <Section key={name}>
      <Title size={6}>{name}</Title>
      <Content size={6}>{value}</Content>
    </Section>
  );
}

export const Delivery: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { className } = props;
  const dicts = useDictionariesFieldsMap();
  const card = useCard();

  return (
    <Table className={className}>
      <tbody>
        {renderTableRow(considerationTimeText(card.considerationTime))}
        {renderTableRow(registrationWayText(dicts.registrationWay, card.registrationWay))}
        {renderTableRow(obtainingMethodText(dicts.microCreditObtainingMethod, card.obtainingMethod))}
      </tbody>
    </Table>
  );
});
